/** Manage the scale from / to page search parameters */

import { logger } from '@tunasong/models'
import { scaleSchema, type Scale } from '@tunasong/schemas'
import { useSearchParams } from '@tunasong/ui-lib'
import { useCallback, useEffect, useState } from 'react'

export const usePageScale = (defaultScale?: Scale | null) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [scale, setScaleInternal] = useState<Scale | null>(defaultScale ?? null)

  useEffect(() => {
    const scaleParams = searchParams.get('scale')

    if (!scaleParams) {
      return
    }
    try {
      const scale = scaleSchema.parse(JSON.parse(decodeURIComponent(scaleParams)))
      setScaleInternal(scale)
    } catch (e) {
      logger.error('Invalid page scale params', scaleParams, e)
    }
  }, [searchParams])

  const setScale = useCallback(
    (newScale: Scale | null) => {
      const scale = encodeURIComponent(JSON.stringify(newScale))
      setSearchParams(
        prev => ({
          ...Object.fromEntries(prev.entries()),
          scale,
        }),
        {
          replace: true,
        }
      )
    },
    [setSearchParams]
  )
  return [scale, setScale] as const
}
